import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '@composite/evidence/dictionary-evidence';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { DictCountry } from '@models';
import {
  EntityName,
  EvidenceApiUrl,
  ExportTags,
  HistoryEntityType,
} from '@enums';
import { Fields } from './dict-country-fields';
import { useValidationSchema } from './dict-country-schema';

export function DictCountries() {
  const validationSchema = useValidationSchema();
  const intl = useIntl();
  const { columnName, columnActive, columnCode } =
    DictionaryEvidence.useDictionaryColumns<DictCountry>();

  const evidence = useDictionaryEvidence<DictCountry>({
    version: 2,
    identifier: 'COUNTRIES',
    apiProps: {
      url: EvidenceApiUrl.DICT_COUNTRIES,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.COUNTRY,
      }),
    },
    tableProps: {
      columns: [columnCode, columnActive, columnName],
      tableName: intl.formatMessage({
        id: 'ES__DICT_COUNTRIES__TABLE__TITLE',
        defaultMessage: 'Země',
      }),
      reportTag: ExportTags.DICT_COUNTRIES,
      defaultSorts: [
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
      ],
    },
    detailProps: {
      entityName: EntityName.COUNTRY,
      GeneralFieldsComponent: Fields,
      validationSchema,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DICT_COUNTRIES__DETAIL__TITLE',
          defaultMessage: 'Země',
        }),
      },
    },
  });

  return <Evidence {...evidence} />;
}
